
<div class="dialog-header">
  <h1 mat-dialog-title>{{ type }} Item</h1>
  <button *ngIf="!isItemSaved" mat-dialog-close  class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
    <div *ngIf="!isItemSaved">
  <mat-form-field>
    <input matInput [(ngModel)]="item_name" placeholder="Item Name" [disabled]="isInputDisabled">
  </mat-form-field>
  <mat-form-field>
    <input matInput [(ngModel)]="description" placeholder="Enter Description" [disabled]="isInputDisabled">
  </mat-form-field>

  <mat-form-field>
    <mat-select [(ngModel)]="unit_id" placeholder="Select Unit" [disabled]="isInputDisabled"
      panelClass="no-close-dropdown" (openedChange)="filterUnits()">
      <mat-option>
        <mat-form-field style="width: 100%; padding: 5px;">
          <input matInput placeholder="Search Unit" [(ngModel)]="searchUnitText" (ngModelChange)="filterUnits()"
            (click)="$event.stopPropagation()" />
        </mat-form-field>
      </mat-option>
      <mat-option *ngFor="let type of filteredUnitData" [value]="type.id">
        {{ type.unit_name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  
  <mat-form-field>
    <mat-select [(ngModel)]="hsn_id" placeholder="Select HSN" [disabled]="isInputDisabled">
      <mat-option *ngFor="let type of hsn_data" [value]="type.id">{{ type.hsn_sac_no }}</mat-option>
    </mat-select>
  </mat-form-field>
    </div>
     <!-- CATEGORY FORM -->
   <div *ngIf="isItemSaved">
    <mat-form-field>
      <mat-select [(ngModel)]="category_id" placeholder="Select Category">
        <mat-option *ngFor="let type of category_data" [value]="type.id">
          {{ type.category_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
     <mat-form-field>
    <mat-select [(ngModel)]="expense_type" placeholder="Select Expense Type">
      <mat-option *ngFor="let type of expense_types" [value]="type">{{ type }}</mat-option>
    </mat-select>
  </mat-form-field>
  </div>
</div>

<div mat-dialog-actions>
      <button mat-button class="btn btn-success"  *ngIf="button" (click)=" SaveItem()">{{type}}</button>
  <button mat-button class="btn btn-danger" mat-dialog-close  [disabled]="isItemSaved">Cancel</button>
</div>
